export const MENU_SCROLLED_TOP_POSITION = 2;

export const CMD = {
  NEXT: 'NEXT',
  PREV: 'PREV',
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
  FIRST: 'FIRST',
  LAST: 'LAST',
};

export const KEY_CMD_MAP_VERTICAL = {
  ArrowDown: CMD.NEXT,
  ArrowUp: CMD.PREV,
  ArrowRight: CMD.OPEN,
  ArrowLeft: CMD.CLOSE,
  Escape: CMD.CLOSE,
  Home: CMD.FIRST,
  End: CMD.LAST,
};
export const KEY_CMD_MAP_HORIZONTAL = {
  ArrowRight: CMD.NEXT,
  ArrowLeft: CMD.PREV,
  ArrowDown: CMD.OPEN,
  Escape: CMD.CLOSE,
  Home: CMD.FIRST,
  End: CMD.LAST,
};
